// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-common-facets-FacetsDropdown-module__root--2dlr4","popover":"src-components-common-facets-FacetsDropdown-module__popover--2iAtI"};